const MessageStatus = {
    REGULAR: 'regular',
    STARTING: 'starting',
    WARNING: 'warning'
}

export default MessageStatus;
